import Model from 'flarum/common/Model';
import mixin from 'flarum/common/utils/mixin';

export default class Advcomment extends mixin(Model, {
    content: Model.attribute('content'),
    contentHtml: Model.attribute('contentHtml'),
    user_id: Model.attribute('user_id'),
    post_id: Model.attribute('post_id'),
    created_at: Model.attribute('created_at'),
    isUpVote: Model.attribute('isUpVote'),
    isDownVote: Model.attribute('isDownVote'),
    advcomment_id: Model.attribute('advcomment_id'),
    upvotes: Model.attribute('upvotes'),
    votes: Model.attribute('votes'),
    votesSum: Model.attribute('votesSum'),
    user: Model.hasOne('user'),
    post: Model.hasOne('post'),
    upvotes: Model.hasMany('upvotes'),
    downvotes: Model.hasMany('downvotes'),
    flags: Model.hasMany('flags'),
}) {}
